import { twJoin } from "tailwind-merge";
import { useState } from "react";
import JobApplicationSectionList from "../components/job-application/JobApplicationSectionList";
import JobApplication, { JobApplicationType } from "../components/JobApplication";
const JobApplicationPage = () => {
  return (
    <div
      className={twJoin(
        "text-left bg-white sm:mt-[25px] mt-0 font-poppins text-13 font-semibold text-[#858795] tracking-[-0.03rem] w-full h-full rounded-xl pb-8 sm:pb-9 "
      )}
    >
      <JobApplicationSectionList />
    </div>
  );
};
export default JobApplicationPage;
